function updateStepView(stepsIndex) {
  jQuery(".mobile-step-wrapper > div").removeClass("mobile-step-active")

  if (stepsIndex == 1) {
    jQuery(".progress-container .progress-bar").animate({ width: "14%" })
    jQuery(".paso p .steps").text(stepsIndex)
    jQuery(".paso .back-to").addClass("peidetud")
    jQuery(".mobile-step-wrapper .step1-title").addClass("mobile-step-active")
  }

  if (stepsIndex == 2) {
    jQuery(".progress-container .progress-bar").animate({ width: "29%" })
    jQuery(".paso p .steps").text(stepsIndex)
    jQuery(".mobile-step-wrapper .back-to").addClass("peidetud")
    jQuery(".mobile-step-wrapper .step2-title").addClass("mobile-step-active")
  }

  if (stepsIndex == 3) {
    jQuery(".progress-container .progress-bar").animate({ width: "43%" })
    jQuery(".paso p .steps").text(stepsIndex)
    jQuery(".mobile-step-wrapper .step3-title").addClass("mobile-step-active")
  }

  if (stepsIndex == 4) {
    jQuery(".progress-container .progress-bar").animate({ width: "57%" })
    jQuery(".paso p .steps").text(stepsIndex)
    jQuery(".mobile-step-wrapper .step4-title").addClass("mobile-step-active")
  }

  if (stepsIndex == 5) {
    jQuery(".progress-container .progress-bar").animate({ width: "71%" })
    jQuery(".paso p .steps").text(stepsIndex)
    jQuery(".mobile-step-wrapper .step5-title").addClass("mobile-step-active")
  }

  jQuery("html, body").animate({ scrollTop: 0 }, "slow")
}
